import { EditedReportChatType } from "./types";

//Use constants from router config (router-edit-modal)

export const formInitState: EditedReportChatType = {
  name: "",
  authGroups: [],
  auth_groups: new Set(),
  enabled: true,
  data: {
    room: [],
    game_group: [],
    game_type: [],
    technology: [],
    aid: [],
    cid: [],
    rules: [],
    chat_id: "",
    bot_id: "",
  },
};
